var map = {
	"./facebook-circle-primary.svg": 86,
	"./facebook-circle-white.svg": 87,
	"./instagram-circle-primary.svg": 88,
	"./instagram-circle-white.svg": 89,
	"./keyboard-arrow-down-white.svg": 12,
	"./mars-primary.svg": 90,
	"./play-circle-outline-white.svg": 13,
	"./twitter-circle-primary.svg": 91,
	"./twitter-circle-white.svg": 92,
	"./venus-primary.svg": 93
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons ^\.\/.*$
// module id = 126
// module chunks = 0